//#region Util Imports

import * as _ from 'underscore'

//#endregion

export type IMRBaseComponentOptions = {
    controller: any
    template: string

    isContainer?: boolean
    services?: string[]
    bindings?: Record<string, string>
}

export abstract class IMRBaseComponent implements ng.IComponentOptions {

    //#region Members

    bindings = {
        options: '<'
    }

    restrict = 'E'

    template: string
    transclude: boolean
    controller: any[]

    //#endregion


    //#region Ctor

    constructor(private options: IMRBaseComponentOptions) {
        if (this.options != null) {
            this.template = this.options.template
            this.transclude = this.options.isContainer || false

            const services: string[] = this.options.services || []

            this.controller = [...services, this.options.controller]

            if (options.bindings != null) {
                _.assign(this.bindings, options.bindings)
            }
        }
    }

    //#endregion
}
